import React, { useState, useEffect } from "react";
import "./RandomImages.scss";

export default function RandomImages() {

    const [imgIndex1, setImgIndex1] = useState(0)
    const [imgIndex2, setImgIndex2] = useState(0)
    const [imgIndex3, setImgIndex3] = useState(0)

    const images = [
        {
            src: "/wp-content/uploads/more-impact-images/1-min.png",
            alt: "1-min.png"
        },
        {
            src: "/wp-content/uploads/more-impact-images/2-min.png",
            alt: "2-min.png"
        },
        {
            src: "/wp-content/uploads/more-impact-images/3-min.png",
            alt: "3-min.png"
        },
        {
            src: "/wp-content/uploads/more-impact-images/4-min.jpg",
            alt: "4-min.jpg"
        },
        {
            src: "/wp-content/uploads/more-impact-images/5-min.jpg",
            alt: "5-min.jpg"
        },
        {
            src: "/wp-content/uploads/more-impact-images/6-min.jpg",
            alt: "6-min.jpg"
        },
        {
            src: "/wp-content/uploads/more-impact-images/7-min.jpg",
            alt: "7-min.jpg"
        },
        {
            src: "/wp-content/uploads/more-impact-images/8-min.jpg",
            alt: "8-min.jpg"
        },
        {
            src: "/wp-content/uploads/more-impact-images/9-min.jpg",
            alt: "9-min.jpg"
        },
    ];

    const randomInteger = (min, max) => {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    useEffect(() => {
        const displayRandomImage = () => {
            setImgIndex1(randomInteger(0, 2))
            setImgIndex2(randomInteger(3, 5))
            setImgIndex3(randomInteger(6, 8))
        };
        displayRandomImage()
    }, [])

    return (
        <div>
            <div className="random-images-group">
                <div className="random-landing-page-image">
                    <img
                        src={images[imgIndex1].src}
                        alt={images[imgIndex1].alt}
                    />
                </div>
                <div className="random-landing-page-image">
                    <img
                        src={images[imgIndex2].src}
                        alt={images[imgIndex2].alt}
                    />
                </div>
                <div className="random-landing-page-image">
                    <img
                        src={images[imgIndex3].src}
                        alt={images[imgIndex3].alt}
                    />
                </div>
            </div>
        </div>
    );
}
